import { PureComponent } from 'react';

import CmsBlock from 'Component/CmsBlock';
import Field from 'Component/Field';
import FIELD_TYPE from 'Component/Field/Field.config';
import Form from 'Component/Form';
import Image from 'Component/Image';
import Loader from 'Component/Loader';
import Popup from 'Component/Popup';
import { getUrlMedia } from 'Util/Store';
import { VALIDATION_INPUT_TYPE } from 'Util/Validator/Config';

import './YBRecomendadorTalla.style';

/** @namespace Elganso/Component/YBRecomendadorTalla/Component */
export class YBRecomendadorTalla extends PureComponent {
    handleTabClicked = this.handleTabClicked.bind(this);

    handleTabClicked(e, tab) {
        const { onPopupTabClicked } = this.props;

        e.preventDefault();
        onPopupTabClicked(tab);
    }

    renderTabsPopup() {
        const { activePopupTab } = this.props;

        return (
            <div block="YBRecomendadorTalla" elem="PopupTabs">
                <span
                  className={ activePopupTab === 'GUIA' ? 'popupTab activePopupTab' : 'popupTab' }
                  onClick={ (e) => this.handleTabClicked(e, 'GUIA') }
                  onKeyDown={ (e) => this.handleTabClicked(e, 'GUIA') }
                >
                    { __('Size Guide') }
                </span>
                <span
                  className={ activePopupTab === 'FORM' ? 'popupTab activePopupTab' : 'popupTab' }
                  onClick={ (e) => this.handleTabClicked(e, 'FORM') }
                  onKeyDown={ (e) => this.handleTabClicked(e, 'FORM') }
                >
                    { __('What is my size?') }
                </span>
            </div>
        );
    }

    renderRecomendadorFormContent() {
        const {
            genderOptions, currentGenderSelected, onGenderSelected,
            yearOptions, currentYearSelected, onYearSelected,
            currentHeightSelected, onHeightChange,
            currentWeightSelected, onWeightChange,
            fittingOptions, currentFittingSelected, onFittingSelected
        } = this.props;

        return (
            <div block="FieldForm" elem="Body">
                <div block="FieldForm" elem="Fields">
                    <div block="FieldForm" elem="Field">
                        <span className="label">{ __('Gender') }</span>
                        <Field
                          key="genero"
                          type={ FIELD_TYPE.select }
                          attr={ {
                              id: 'genero',
                              name: 'genero',
                              defaultValue: currentGenderSelected,
                              noPlaceholder: true
                          } }
                          options={ genderOptions }
                          events={ { onChange: onGenderSelected } }
                          validateOn={ ['onChange'] }
                        />
                    </div>
                    <div block="FieldForm" elem="Field">
                        <span className="label">{ __('Year of birth') }</span>
                        <Field
                          key="year"
                          type={ FIELD_TYPE.select }
                          attr={ {
                              id: 'year',
                              name: 'year',
                              defaultValue: currentYearSelected,
                              noPlaceholder: true
                          } }
                          options={ yearOptions }
                          events={ { onChange: onYearSelected } }
                          validateOn={ ['onChange'] }
                        />
                    </div>
                    <div block="FieldForm" elem="Field">
                        <span className="label">{ __('Height') }</span>
                        <Field
                          key="height"
                          type={ FIELD_TYPE.number }
                          attr={ {
                              id: 'height',
                              name: 'height',
                              defaultValue: currentHeightSelected,
                              min: 1,
                              max: 300,
                              step: 1
                          } }
                          events={ { onChange: (e) => onHeightChange(e) } }
                          validationRule={ {
                              inputType: VALIDATION_INPUT_TYPE.numeric,
                              isRequired: true,
                              range: {
                                  min: 1,
                                  max: 300
                              }
                          } }
                        />
                    </div>
                    <div block="FieldForm" elem="Field">
                        <span className="label">{ __('Weight') }</span>
                        <Field
                          key="weight"
                          type={ FIELD_TYPE.number }
                          attr={ {
                              id: 'weight',
                              name: 'weight',
                              defaultValue: currentWeightSelected,
                              min: 1,
                              max: 300,
                              step: 1
                          } }
                          events={ { onChange: onWeightChange } }
                          validationRule={ {
                              inputType: VALIDATION_INPUT_TYPE.numeric,
                              isRequired: true,
                              range: {
                                  min: 1,
                                  max: 300
                              }
                          } }
                        />
                    </div>
                    <div block="FieldForm" elem="Field">
                        <span className="label">{ __('How do you like your clothes?') }</span>
                        <Field
                          key="fitting"
                          type={ FIELD_TYPE.select }
                          attr={ {
                              id: 'fitting',
                              name: 'fitting',
                              defaultValue: currentFittingSelected,
                              noPlaceholder: true
                          } }
                          options={ fittingOptions }
                          events={ { onChange: onFittingSelected } }
                          validateOn={ ['onChange'] }
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderSubmitButton() {
        return (
            <div block="YBRecomendadorTalla" elem="Buttons">
                <button
                  block="Button"
                  type="submit"
                  mix={ { block: 'YBRecomendadorTalla', elem: 'SubmitButton' } }
                  form="recomendadortallaform"
                >
                    { __('What is my size?') }
                </button>
            </div>
        );
    }

    renderRecomendadorAddToCartbutton() {
        const { addToCart, product: { type_id = '' } } = this.props;

        if (type_id !== 'bundle') {
            return (
                <div block="YBRecomendadorTalla" elem="AddToCart">
                    <button
                      block="YBRecomendadorTalla"
                      elem="AddToCartButton"
                      type="button"
                      onClick={ addToCart }
                    >
                        { __('ADD TO CART') }
                    </button>
                </div>
            );
        }

        return null;
    }

    renderPercentages() {
        const { percentages, recomendedSize } = this.props;

        return (
            <div className="sizeSlider">
                { percentages.map((percentage, index) => {
                    const obj = Object.entries(percentage)[0];
                    const i = index;

                    return (
                        <div className="sizeSlide" key={ i }>
                            <span
                              className={ obj[0] === recomendedSize ? 'recommended' : '' }
                            >
                                { obj[0] }
                            </span>
                            <div className="application-recommend-step-result-bar">
                                <div
                                  className="application-recommend-step-result-bar-percentage"
                                  style={ { marginInlineStart: `calc(${obj[1]}% - 20px)` } }
                                >
                                    { `${obj[1]}%` }
                                </div>
                                <div
                                  className="application-recommend-step-result-bar-space"
                                  style={ {
                                      marginInlineStart: `calc(${obj[1]}% - 10px)`
                                  } }
                                />
                                <div className="application-recommend-step-result-bar-line" />
                            </div>
                        </div>
                    );
                }) }
            </div>
        );
    }

    renderRecomendadorResults() {
        const { percentages = [], recomendedSize, returnToForm } = this.props;

        return (
            <>
                <div block="YBRecomendadorTalla" elem="ContentResult">
                    <div className="title">
                        { __('My size is') }
                    </div>
                    <div className="talla">
                        { recomendedSize === ''
                            ? <Loader isLoading />
                            : recomendedSize }
                    </div>
                    <div className="porcentajes">
                        { recomendedSize === '' || percentages.length === 0
                            ? null
                            : this.renderPercentages() }
                    </div>
                </div>
                { this.renderRecomendadorAddToCartbutton() }
                <div block="YBRecomendadorTalla" elem="ChangeData">
                    <span
                      block="YBRecomendadorTalla"
                      elem="ChangeDataButton"
                      onClick={ returnToForm }
                      onKeyDown={ returnToForm }
                    >
                        { __('Change my details') }
                    </span>
                </div>
            </>
        );
    }

    renderRecomendadorForm() {
        const { submitForm } = this.props;

        return (
            <>
                <div block="YBRecomendadorTalla" elem="ContentHeading">
                    <div className="title">
                        <Image
                          mix={ { block: 'YBRecomendadorTalla', elem: 'GansoIcon' } }
                          src={ `${getUrlMedia()}scandiweb/images/map_marker.png` }
                        />
                        { __('Find your size') }
                    </div>
                    <div className="subtitle">
                        { __('Fill the form') }
                    </div>
                </div>
                <Form
                  mix={ { block: 'YBRecomendadorTalla', elem: 'Form' } }
                  attr={ { name: 'recomendadortallaform', id: 'recomendadortallaform' } }
                  onSubmit={ submitForm }
                  returnAsObject
                >
                    { this.renderRecomendadorFormContent() }
                    { this.renderSubmitButton() }
                </Form>
            </>
        );
    }

    renderContentPopup() {
        const {
            activePopupTab, foundSavedData, product: { type_id = '' }, recomendedSize, returnToGuide
        } = this.props;

        if (activePopupTab === 'GUIA') {
            return (
                <div block="YBRecomendadorTalla" elem="Content" className="guia_tallas">
                    <CmsBlock identifier="guia-de-tallas" />
                </div>
            );
        }

        if (activePopupTab === 'FORM') {
            if (type_id === 'simple') {
                return (
                    <div block="YBRecomendadorTalla" elem="Content">
                        <div block="YBRecomendadorTalla" elem="SimpleAdvice">
                            <span>{ __('We cannot recommend sizes for this product as it is a size-free product.') }</span>
                            <span
                              className="ReturnButton"
                              onClick={ returnToGuide }
                              onKeyDown={ returnToGuide }
                            >
                                { __('Return to size guide') }
                            </span>
                        </div>
                    </div>
                );
            }

            return (
                <div block="YBRecomendadorTalla" elem="Content">
                    { foundSavedData || recomendedSize
                        ? this.renderRecomendadorResults()
                        : this.renderRecomendadorForm() }
                </div>
            );
        }

        return (
            <div block="YBRecomendadorTalla" elem="Content">
                <Loader isLoading />
            </div>
        );
    }

    renderImagePopup() {
        const { product, bundleImg } = this.props;

        let image = `${getUrlMedia()}scandiweb/images/cargando-app.gif`;

        if (product.type_id === 'bundle') {
            image = bundleImg;
        } else if (product.image) {
            image = product.image.url;
        }

        return (
            <Image
              mix={ { block: 'YBRecomendadorTalla', elem: 'Picture' } }
              src={ image }
            />
        );
    }

    renderLayoutPopup() {
        return (
            <div block="YBRecomendadorTalla" elem="PopupBody">
                <div block="YBRecomendadorTalla" elem="PopupImage">
                    { this.renderImagePopup() }
                </div>
                <div block="YBRecomendadorTalla" elem="PopupContent">
                    { this.renderTabsPopup() }
                    { this.renderContentPopup() }
                </div>
            </div>
        );
    }

    renderRecomendadorPopup() {
        const { closePopup, id_pop_up_recomendador } = this.props;

        return (
            <Popup
              id={ id_pop_up_recomendador }
              clickOutside={ false }
              mix={ { block: 'YBRecomendadorTalla', elem: 'Popup' } }
              onClose={ () => closePopup }
            >
                { this.renderLayoutPopup() }
            </Popup>
        );
    }

    render() {
        const {
            showRecomendador, showRecomendadorForm, showGuiaDeTallas, isShowPopup
        } = this.props;

        if (isShowPopup) {
            if (showRecomendador) {
                return (
                    <div block="YBRecomendadorTalla">
                        <button
                          block="YBRecomendadorTalla"
                          elem="Button"
                          type="button"
                          onClick={ showRecomendadorForm }
                        >
                            { __('WHAT IS MY SIZE?') }
                        </button>
                        { this.renderRecomendadorPopup() }
                    </div>
                );
            }

            return (
                <button
                  onClick={ showGuiaDeTallas }
                  rel="noopener noreferrer"
                  target="_blank"
                  className="privacy-policy-link"
                >
                    { __('Size Guide') }
                </button>
            );
        }

        return (
            <div block="YBRecomendadorTalla">
                { this.renderLayoutPopup() }
            </div>
        );
    }
}

export default YBRecomendadorTalla;
